export default ('or', function (a, b) { return a || b; });